module.exports = __webpack_public_path__ + "static/media/hero_img.054a1745.svg";